import { FormOutlined } from '@ant-design/icons'
import { Button, Card, Switch, Table } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AccountBean, ItemResponseNotificationSettingBeanObject, NotificationSettingBean } from 'src/api/api'
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader'
import { enumView } from 'src/util/Util'
import notificationSettingApi from './NotificationSettingApi'

const Column = Table.Column

const formInfoItems: FormDataType[] = [
    FormDataType.Accounts
]

interface Props { }

const NotificationSettingList: React.FC<Props> = () => {

    const [data, setData] = useState<NotificationSettingBean[]>([])

    const [info, setInfo] = useState({
        accounts: [] as AccountBean[]
    })

    const enable = async (record: NotificationSettingBean, index) => {
        await notificationSettingApi.edit(record.id, { ...record, enabled: !record.enabled })

        const bean = data[index]
        bean.enabled = !record.enabled

        setData([...data])
    }

    const loadData = async () => {
        const response = await notificationSettingApi.list()

        const array = response.data as Array<ItemResponseNotificationSettingBeanObject>
        const settingBeans: NotificationSettingBean[] = array.map(item => item.data as NotificationSettingBean)

        settingBeans.sort((a, b) => a.type.toString().localeCompare(b.type.toString()))

        setData(settingBeans)
    }

    const loadInfo = async () => {
        const resp = await formDataLoader(...formInfoItems)
        setInfo(resp as any)
    }

    useEffect(() => {
        loadData()
        loadInfo()
    }, [])

    return <Card
        title="Notification Settings"
        className="list-card"
    >
        <Table
            rowKey="id"
            size="middle"
            dataSource={data}
            pagination={false}
        >
            <Column
                key="type"
                title="Type"
                dataIndex="type"
                render={(text, record: NotificationSettingBean) => <Link to={`/notification-setting/${record.id}/edit`}>{enumView(text).replace('SSPTraffic', 'SSP Traffic')}</Link>}
            />
            <Column
                key="accountIds"
                title="Accounts"
                dataIndex="accountIds"
                render={ids => ids.map(id => info.accounts.find(item => id == item.id)?.name).join(', ')}
            />
            <Column
                align="center"
                key="enabled"
                title="Enabled"
                dataIndex="enabled"
                render={(text, record: NotificationSettingBean, index) => <Switch size="small" checked={record.enabled} onChange={e => enable(record, index)} />}
            />
            <Column align="center" key="action" title="Actions" render={(text: string, record: NotificationSettingBean) =>
                <Link to={`/notification-setting/${record.id}/edit`}>
                    <Button type="text" >
                        <FormOutlined className="actions-btn" />
                    </Button>
                </Link>
            } />
        </Table>
    </Card>
}

export default NotificationSettingList



// WEBPACK FOOTER //
// ./src/component/app/notificationSetting/NotificationSettingList.tsx